import { FC } from "react";


import { ServicesWorkshopPageId } from "utils/useScroll";
import { Box } from "@chakra-ui/react";
import { GrDocumentPerformance } from "react-icons/gr";
import { TbAugmentedReality } from "react-icons/tb";


import ServiceDescriptor from "./ServiceDescriptor";
import NextStepsSection from "./NextSteps";
import { TbSql } from "react-icons/tb";
import { PiFileSqlLight } from "react-icons/pi";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";


export const TechAdviceService: FC = () => {

 const label =  "Workshops and Training";
  const title = "Building institutional knowledge for sustainable data capabilities";
  const footer = "Industry standards workshops and hands on training";
  const services = [
    {
      title: "SQL Mastery for Beginners",
      icon: TbSql,
      items: [
        "Zero to Query Hero – Start with SELECT and master filtering, sorting, and aggregations",
        "Database Basics – Understand tables, relationships, and CRUD operations",
        "Practical Labs – Build a mini-database project from scratch",
        "Career Ready – Learn the 20% of SQL used in 80% of jobs"
        ]
    },
    {
      title: "SQL Mastery for Data Analysts",
      icon: TbDeviceDesktopAnalytics,
      items: [
        "Advanced Analytics – Time-series analysis, cohort queries, and rolling metrics",
        "ETL Techniques – Clean and transform raw data into analysis-ready tables",
        "Visualization Prep – Structure data for tools like Power BI/Tableau",
        "Optimization – Write queries that run 10-100x faster",
      ]
    },
    {
      title: "SQL Mastery for Technical Teams",
      icon: PiFileSqlLight,
      items: [
        "Database Design – Normalization, indexing, and schema optimization", 
        "SQL in App Code – Parameterized queries and ORM alternatives",
        "Security – Prevent injection and manage permissions",
        "Debugging – Log and troubleshoot slow/erroneous queries"
        ]
    }
    
  ];
  return (
    <Box id={ServicesWorkshopPageId}>
      <ServiceDescriptor title={title} label={label} footer={footer} services={services}  prevRoute="/orgs"/>
      {/* <DeliverablesSection deliverables={[
            {
              icon: FaBug,
              title: "Risk Assessment Report",
              description: "Prioritized list of vulnerabilities with severity ratings",
              tags: ["Critical/High/Medium"]
            },
            {
              icon: FaChartBar,
              title: "Performance Simulation",
              description: "Load test results at 3x/5x/10x current traffic",
              tags: ["Metrics", "Benchmarks"]
            },
            {
              icon: FaProjectDiagram,
              title: "Architecture Blueprint",
              description: "Future-state diagram with upgrade pathways",
              tags: ["Visio", "Draw.io"]
            },
            {
              icon: FaMoneyBillWave,
              title: "Cost Optimization Plan",
              description: "Infrastructure savings opportunities (30/60/90 day)",
              tags: ["ROI Analysis"]
            }
          ]} /> */}
    <NextStepsSection title="Ready to Build Institutional Knowledge that Matters?" 
      message="Take the next step toward meaningful workshops" 
      actionHeading="Schedule Discussion" 
      actionText="Book a 90-minute discovery session to discuss your specific training needs" 
      actionLabel="Contact Me and Book Today"/>
      
    </Box>

  );
  
}
export default TechAdviceService;
